import Lenis from "lenis";

let lenisInstance = null;

export const initLenis = () => {
  lenisInstance = new Lenis({
    duration: 1.2,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t))
  });

  const raf = (time) => {
    lenisInstance.raf(time);
    requestAnimationFrame(raf);
  };
  requestAnimationFrame(raf);
};

export const destroyLenis = () => {
  lenisInstance?.destroy();
  lenisInstance = null;
};

export const scrollToTop = () => {
  lenisInstance?.scrollTo(0, {
    duration: 2.1,
    easing: (t) =>
      t === 0 || t === 1
        ? t
        : t < 0.5
          ? Math.pow(2, 20 * t - 10) / 2
          : (2 - Math.pow(2, -20 * t + 10)) / 2,
  });
  window.history.replaceState(null, "", window.location.pathname);
};

export const scrollToSection = (id) => {
  const target = document.getElementById(id);
  if (target && lenisInstance) {
    lenisInstance.scrollTo(target, {
      offset: 0,
      duration: 2.1,
      easing: (t) =>
        t === 0 || t === 1
          ? t
          : t < 0.5
            ? Math.pow(2, 20 * t - 10) / 2
            : (2 - Math.pow(2, -20 * t + 10)) / 2,
    });
  }
};
